module.exports = __webpack_public_path__ + "img/bank_kalsel.68c21895.png";